import { createContext, useCallback, useContext, useEffect, useState } from "react";
import {
  SolarPanel, Cpu, BatteryCharging, GridFour, Columns, Square, Wrench, Nut, PlugsConnected,
  Pipe, Anchor, Lightning, Plug, Tag, Package,
} from "@phosphor-icons/react";
import { api, API } from "./api";

const RULES = [
  [/^panels$|panel/i, SolarPanel, "bg-amber-100 text-amber-700 ring-amber-200"],
  [/^inverters$|inverter/i, Cpu, "bg-sky-100 text-sky-700 ring-sky-200"],
  [/^batteries$|battery/i, BatteryCharging, "bg-emerald-100 text-emerald-700 ring-emerald-200"],
  [/acdb|dcdb|box/i, GridFour, "bg-violet-100 text-violet-700 ring-violet-200"],
  [/rafter|purlin|pillar|leg|पाए/i, Columns, "bg-slate-200 text-slate-700 ring-slate-300"],
  [/plate/i, Square, "bg-slate-200 text-slate-700 ring-slate-300"],
  [/clamp/i, Wrench, "bg-slate-200 text-slate-700 ring-slate-300"],
  [/nut|bolt|fastener/i, Nut, "bg-zinc-200 text-zinc-700 ring-zinc-300"],
  [/earthing rod/i, Anchor, "bg-lime-100 text-lime-700 ring-lime-200"],
  [/wire|cable(?! tie)/i, PlugsConnected, "bg-rose-100 text-rose-700 ring-rose-200"],
  [/pipe|tray/i, Pipe, "bg-orange-100 text-orange-700 ring-orange-200"],
  [/lightning|arrester/i, Lightning, "bg-yellow-100 text-yellow-700 ring-yellow-200"],
  [/mc4|connector/i, Plug, "bg-indigo-100 text-indigo-700 ring-indigo-200"],
  [/tie/i, Tag, "bg-teal-100 text-teal-700 ring-teal-200"],
];

export const defaultIconFor = (key = "") => {
  const hit = RULES.find(([re]) => re.test(key));
  return hit ? { Icon: hit[1], tone: hit[2] } : { Icon: Package, tone: "bg-slate-100 text-slate-600 ring-slate-200" };
};

export const iconUrl = (key, v) => `${API}/material-icons/image?key=${encodeURIComponent(key)}&v=${v}`;

const Ctx = createContext({ icons: {}, reload: () => {} });

export function MaterialIconsProvider({ children }) {
  const [icons, setIcons] = useState({});
  const reload = useCallback(() => api.get("/material-icons").then((r) => setIcons(r.data)).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  return <Ctx.Provider value={{ icons, reload }}>{children}</Ctx.Provider>;
}

export const useMaterialIcons = () => useContext(Ctx);

export function MaterialIcon({ iconKey, size = 40, className = "" }) {
  const { icons } = useMaterialIcons();
  const v = icons[iconKey];
  const { Icon, tone } = defaultIconFor(iconKey);
  const box = { width: size, height: size };
  if (v) {
    return <img src={iconUrl(iconKey, v)} alt={iconKey} crossOrigin="anonymous" style={box}
      className={`rounded-lg object-cover ring-1 ring-slate-200 bg-white shrink-0 ${className}`} data-testid={`material-icon-${iconKey}`} />;
  }
  return (
    <span style={box} className={`rounded-lg ring-1 flex items-center justify-center shrink-0 ${tone} ${className}`} data-testid={`material-icon-${iconKey}`}>
      <Icon size={Math.round(size * 0.58)} weight="duotone" />
    </span>
  );
}
